import { Component, TrackByFunction } from '@angular/core';
import { getTrackByIndexFn } from '@y42/angular/util';
import { TypescriptTypeEnum } from '@y42/monaco-typescript-types';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { MarkdownService } from 'ngx-markdown';
import { FunctionDefinitionModel, FunctionParameter } from '../../../../models/function-definition.model';

@Component({
  selector: 'y42-function-details-renderer',
  templateUrl: './function-details-renderer.component.html',
  styleUrls: ['./function-details-renderer.component.scss'],
})
export class FunctionDetailsRendererComponent implements ICellRendererAngularComp {
  constructor(private readonly markdownService: MarkdownService) {
    const renderer = this.markdownService.renderer;
    const linkRenderer = renderer.link;
    this.markdownService.renderer.link = (href: string, title: string, text: string) => {
      const html = linkRenderer.call(renderer, href, title, text);
      return html.replace(/^<a /, '<a target="_blank"');
    };
  }

  readonly trackByFuncDefParamsIndex = getTrackByIndexFn<FunctionParameter>();

  params!: ICellRendererParams;
  functionDefinition?: FunctionDefinitionModel;
  typescriptTypeEnum = TypescriptTypeEnum;

  readonly trackByStringIndex: TrackByFunction<string> = (index) => index;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.functionDefinition = this.params.data;
    if (this.functionDefinition) {
      this.functionDefinition.parameters = this.functionDefinition.parameters
        .sort((a: FunctionParameter, b: FunctionParameter) => {
          if (a.index < b.index) {
            return -1;
          } else if (a.index > b.index) {
            return 1;
          }
          return 0;
        })
        .map((param) => ({
          ...param,
          splittedByVerticalLineTsTypes: param.typescript_type.split(' | '),
        }));
    }
  }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    this.functionDefinition = this.params.data;
    return false;
  }
}
